import React from "react";
import ThemeProviderWrapper from "./theme/ThemeProviderWrapper";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <ThemeProviderWrapper>
      <BrowserRouter basename="/smart-meter/app">
        {/* basename="/smart-meter/app" */}
        <AppRoutes  />
      </BrowserRouter>
    </ThemeProviderWrapper>
  );
}

export default App;
